<template>
    <div class="col-sm-6 col-md-6 col-lg-4 p-3">
        <vue-card>
            <!-- <header slot="header">{{sensor.alias}}</header> -->
            <div class="details">
                <div class="temp">
                    {{ formatTemp(sensor.reading)}}
                    <span>{{ sensor.unit}}</span>
                </div>
                <div class="right">
                    <div id="summary">{{sensor.alias}}</div>
                    <div id="date">{{ timestamp }}</div>
                </div>
            </div>

            <!-- <p>{{ $t('temperatureCurrent')}}: {{ sensor.reading}} {{ sensor.unit}}</p> -->
            <vue-chart v-if="loaded" :chartdata="chartdata" :options="options" />
            <!-- <form>
                <div class="form-row">
                    <div class="form-group col-md-6 col-lg-9">
                        <input type="number" class="form-control" v-model="controller.setpoint" />
                    </div>
                    <div class="form-group col-md-6 col-lg-3">
                        <button
                            class="btn btn-primary w-100"
                            @click="setSetpoint(controller.name, controller.setpoint)"
                        >Save</button>
                    </div>
                </div>
            </form>-->
            <footer slot="footer" class="small">
                {{$t('lastupdate')}}: {{ timestampLong }}
                <a
                    class="float-right"
                    data-toggle="collapse"
                    :href="'#'+collapseName"
                    role="button"
                    aria-expanded="false"
                    :aria-controls="collapseName"
                >Show details</a>
                <div class="collapse" :id="collapseName">
                    <hr />
                    <pre class="small">
                        <p class v-for="(item, name) in sensor" :key="name">{{ name }}: {{item}}</p>
                    </pre>
                </div>
            </footer>
        </vue-card>
    </div>
</template>

<style scoped>
.danger {
    border: 1px solid red;
}

.details {
    top: 0;
    left: 0;
    right: 0;

    color: #888;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.details .right {
    text-align: right;
}

.details #date {
    margin: 4px 0;
}

.details #summary {
    font-weight: 600;
    font-size: 22px;
}

.details .temp {
    font-size: 60px;
    line-height: 60px;
}

.details .temp span {
    font-size: 18px;
    line-height: 30px;
    vertical-align: top;
}
</style>

<script>
import moment from "moment";
import axios from "axios";
//import LineChart from './baase-components/VChart.vue'

export default {
    components: {
        //lineChart: LineChart ,
    },
    props: ["sensor"],
    //extends: Line,
    data() {
        return {
            quantity: 0,
            collapseName: "collapsePre" + this.sensor.name,
            labels: [],
            values: [],
            chartdata: [],
            options: { responsive: true },
            loaded: false,
            datacollection: { labels:[], datasets: {data: []}},
        };
    },
    async mounted() {
        //this.getHistory();
        //this.fillData();
        //this.renderChart(this.datacollection, this.options);
    },
    computed: {
        timestampLong: function () {
            return moment(this.sensor.timestamp).format(
                "dddd DD.MM.YYYY HH:mm"
            );
        },
        timestamp: function () {
            return moment(this.sensor.timestamp).format("DD.MM.YYYY HH:mm");
        },
    },
    methods: {
        formatTemp(value) {
            let val = (value / 1).toFixed(1).replace(".", ",").trim();
            return val;
            //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        formatTimestamp : function (value) {
             return moment(value).format("DD.MM.YYYY HH:mm");
        },
        formatTimestampWithSeconds : function (value) {
             return moment(value).format("DD.MM.YYYY HH:mm:ss");
        },


        fillData() {
            let app = this;
            app.loaded = false;
            return axios
                .get("/" + app.sensor.name + "/history")
                .then((res) => {
                    console.log(res.data);
                    for (var item in res.data) {
                        // var data = { labels: item.timestamp, data: item.value };
                        app.datacollection.datasets.data.push(
                            res.data[item].value
                        );
                        app.datacollection.labels.push(
                            res.data[item].timestamp
                        );

                        app.labels.push(app.formatTimestampWithSeconds(res.data[item].timestamp))
                        app.values.push(res.data[item].value)
                    }

                    //app.sensors = Object.entries(res.data)
                    console.log(
                        "datacollection :" + JSON.stringify(app.datacollection)
                    );
                    app.loaded = true;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(
                    (app.chartdata = {
                        labels: app.labels,
                        datasets: [
                            {
                                label: "Data One",
                                data: app.values,
                            },
                        ],
                    })
                );
        },
    },
};
</script>

